import React, { useState } from 'react';
import theme from '../../../theme/globalTheme';
import { Form, Input, Button, Checkbox, Typography, message } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { supabase } from '../../../api/supabase';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

const { Title, Text } = Typography;

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: values.email,
        password: values.password,
      });

      if (error) throw error;
      if (data.user) {
        navigate('/services-dashboard');
      }
    } catch (error) {
      message.error('Erreur de connexion: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: theme.colors.bgDark, padding: '20px' }} className="login-page">
      <div className="login-left">
        <div className="login-form-container">
          <div className="mb-8">
            <Title level={2} className="!m-0 !text-2xl font-bold">
              Mon espace administrateur
            </Title>
            <Text className="block mt-2 text-gray-600">
              Entrez vos identifiants pour accéder aux données de votre service.
            </Text>
          </div>

          <Form
            name="login"
            onFinish={onFinish}
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: 'Veuillez entrer votre email' },
                { type: 'email', message: 'Email invalide' }
              ]}
            >
              <Input placeholder="Entrez votre adresse email" />
            </Form.Item>

            <Form.Item
              name="password"
              label="Mot de passe"
              rules={[{ required: true, message: 'Veuillez entrer votre mot de passe' }]}
            >
              <Input.Password 
                placeholder="Entrez votre mot de passe"
                iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
              />
            </Form.Item>

            <div className="flex justify-between items-center mb-6">
              <Checkbox>Se souvenir de moi</Checkbox>
              <Button type="link" className="!p-0">
                Mot de passe oublié ?
              </Button>
            </div>

            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
            >
              Se connecter
            </Button>

            <div className="mt-6 text-center">
              <Text className="text-gray-600">
                Vous n'avez pas de compte ?{' '}
                <Button type="link" className="!p-0">
                  Inscrivez-vous ici
                </Button>
              </Text>
            </div>
          </Form>
        </div>
      </div>

      <div className="login-right">
        <div className="login-logo-content">
         
          <img 
            src="https://vlakljvouimjemxbcnmo.supabase.co/storage/v1/object/public/media/icon.jpg"
            alt="Logo"
            className="login-logo"
          />
        
        </div>
      </div>
    </div>
  );
};

export default LoginPage;